import { Layers } from 'react-feather'

const BulkIcon = ({ ...props }: React.SVGProps<SVGSVGElement>) => (
  <Layers {...props} stroke={'currentColor'} fill="none" />
)

export default BulkIcon
